import type { HTMLAttributes } from 'react';
import { cn } from '@/lib/utils/cn';

interface SkeletonProps extends HTMLAttributes<HTMLDivElement> {
  /** Forma do placeholder. */
  shape?: 'rect' | 'circle' | 'pill';
}

const SHAPE_CLASSES: Record<NonNullable<SkeletonProps['shape']>, string> = {
  rect: 'rounded-md',
  circle: 'rounded-full aspect-square',
  pill: 'rounded-full',
};

/**
 * Placeholder de loading respeitando reduced-motion (sem animação se preferir).
 * Cor: tom degraded sutil sobre paper.
 */
export function Skeleton({ shape = 'rect', className, ...rest }: SkeletonProps) {
  return (
    <div
      aria-hidden="true"
      className={cn(
        'bg-surface-muted',
        SHAPE_CLASSES[shape],
        'motion-safe:animate-pulse',
        className,
      )}
      {...rest}
    />
  );
}
